import { RestClient } from "clients/rest";

export type B100220FindRequest = {
  haederHaisorouteNo: string;
} & Partial<{
  tokuiCd: string;
  tokuishitenCd: string;
  shohinshubetsuKbn: string;
}>;

export type B100220FindResponse = {
  tokuiCd: string;
  tokuishitenCd: string;
  nonyuCd: string;
  nonyushitenCd: string;
  nonyuNm: string;
  haisorouteNo: string;
  haisojuni: string;
  version: number;
};

export const B100220Find = (props: B100220FindRequest) => {
  return RestClient.get<B100220FindResponse[]>("b100220/find", {
    params: props,
  });
};

export type B100220CreateRequest = {
  tokuiCd: string;
  tokuishitenCd: string;
  nonyuCd: string;
  nonyushitenCd: string;
  headerHaisorouteNo: string;
  haisojuni: string;
  shohinshubetsuKbn: string;
};

// 登録処理
export const B100220Create = (data: B100220CreateRequest) => {
  return RestClient.post("b100220/create", data);
};

export type B100220UpdateRequest = {
  tokuiCd: string;
  tokuishitenCd: string;
  nonyuCd: string;
  nonyushitenCd: string;
  haisorouteNo: string;
  defaultHaisojuni: string;
  haisojuni: string;
  version: number;
};

// 更新処理
export const B100220Update = (data: B100220UpdateRequest) => {
  return RestClient.put("b100220/update", data);
};

export type B100220DeleteRequest = {
  tokuiCd: string;
  tokuishitenCd: string;
  nonyuCd: string;
  nonyushitenCd: string;
  haisorouteNo: string;
  haisojuni: string;
};

// 削除処理
export const B100220Delete = (data: B100220DeleteRequest) => {
  return RestClient.delete("b100220/delete", { data: data });
};
